import { motion, useReducedMotion } from 'framer-motion';

const backgroundImage = 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/cyber%20security/bg_image.webp';

const highlights = [
  {
    title: 'Proactive Security',
    description: 'Threats handled before the team wakes up.',
    image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/cyber%20security/proactive_security.webp',
    imageAlt: 'Automated proactive security response workflow',
    entrance: { x: -72, y: 0 },
  },
  {
    title: 'Penetration Testing',
    description: "Know what's coming before it arrives.",
    image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/cyber%20security/penetration_testing.webp',
    imageAlt: 'Security audit and penetration testing workflow',
    entrance: { x: 0, y: 56 },
  },
  {
    title: 'Endpoint Security',
    description: 'Every device protected. Every edge secured.',
    image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/cyber%20security/endpoint_security.webp',
    imageAlt: 'Endpoint security protection controls',
    entrance: { x: 72, y: 0 },
  },
];

export default function CybersecurityHighlights() {
  const reduceMotion = useReducedMotion();

  return <section
    className="px-5 py-16 sm:px-6 sm:py-20 lg:px-10 lg:py-12"
    style={{ backgroundColor: '#ffffff' }}
    aria-labelledby="cyber-highlights-title"
  >
    <div className="mx-auto max-w-7xl">
      <motion.header
        className="mx-auto mb-11 max-w-7xl text-left sm:mb-14"
        initial={reduceMotion ? false : { opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.65 }}
        transition={{ duration: reduceMotion ? 0 : 0.65, ease: [0.22, 1, 0.36, 1] }}
      >
        <p className="mb-3 text-center uppercase tracking-[0.24em] text-base font-normal leading-[27px]" style={{ color: '#212121', textAlign: 'left' }}>Security at every layer</p>
        <h2 id="cyber-highlights-title" className="text-[32px] font-semibold leading-[48px]" style={{ color: '#183762' }}>Built to Find risk before it becomes disruption</h2>
      </motion.header>

      <div className="grid gap-10 md:grid-cols-3 md:gap-5 lg:gap-8">
        {highlights.map((item, index) => <motion.article
          key={item.title}
          initial={reduceMotion ? false : { opacity: 0, ...item.entrance }}
          whileInView={{ opacity: 1, x: 0, y: 0 }}
          viewport={{ once: true, amount: 0.22 }}
          transition={{ duration: reduceMotion ? 0 : 0.8, delay: reduceMotion ? 0 : index * 0.08, ease: [0.22, 1, 0.36, 1] }}
          className="group min-w-0"
        >
          <div
            className="relative flex aspect-[5/6] items-center justify-center overflow-hidden p-[14%] transition-transform duration-500 ease-out group-hover:-translate-y-1.5"
            style={{ backgroundImage: `url('${backgroundImage}')`, backgroundPosition: 'center', backgroundSize: 'cover' }}
          >
            <div className="absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100" style={{ background: 'linear-gradient(145deg, rgba(255,255,255,0.17), rgba(38,73,190,0.08))' }} aria-hidden="true" />
            <img
              src={item.image}
              alt={item.imageAlt}
              className="relative z-10 h-auto max-h-full w-full object-contain shadow-[0_24px_65px_rgba(5,18,68,0.22)] transition-transform duration-500 ease-out group-hover:scale-[1.025]"
              loading="lazy"
              decoding="async"
            />
          </div>
          <h3 className="mt-7 text-lg text-center font-semibold leading-tight tracking-[-0.025em]" style={{ color: '#183762' }}>{item.title}</h3>
          </motion.article>)}
      </div>
    </div>
  </section>;
}
